import type { ReactNode } from "react";
import { cn } from "../../lib/cn";

export type BadgeTone =
	| "neutral"
	| "positive"
	| "negative"
	| "warning"
	| "info"
	| "muted";

const TONE: Record<BadgeTone, string> = {
	neutral: "bg-slate-800 text-slate-300",
	positive: "bg-emerald-500/10 text-emerald-300",
	negative: "bg-rose-500/10 text-rose-300",
	warning: "bg-amber-500/10 text-amber-300",
	info: "bg-sky-500/10 text-sky-300",
	muted: "bg-slate-800/60 text-slate-400",
};

interface BadgeProps {
	tone?: BadgeTone;
	className?: string;
	uppercase?: boolean;
	children: ReactNode;
}

/** Pill-shaped label (small, uppercase by default). */
export function Badge({
	tone = "neutral",
	uppercase = true,
	className,
	children,
}: BadgeProps) {
	return (
		<span
			className={cn(
				"rounded-full px-2 py-0.5 text-[10px] font-medium tracking-wide",
				uppercase && "uppercase",
				TONE[tone],
				className,
			)}
		>
			{children}
		</span>
	);
}
